// extracted by mini-css-extract-plugin
export default {"components":"components_components__D7R-H","form":"components_form__Bbuj9","flow":"components_flow__2R0Jx","stack":"components_stack__td55g"};